import React, { useState } from "react"

import { Helmet } from 'react-helmet-async';

import { capitalizeString } from "../utils/formatString"

export const headTitles = {

    access: "Access",
    dashboard: "Dashboard",
    password: "Change Password",
    profile: "Update Profile",
    signup: "Sign Up",

    administrators: "Administrators",
    newAdministrator: "New Administrator",
    updateAdministrator: "Update Administrator",
    viewAdministrator: "View Administrator",
    customers: "Customers",
    newCustomer: "New Customer",
    updateCustomer: "Update Customer",
    viewCustomer: "View Customer",
    workers: "Workers",
    newWorker: "New Worker",
    updateWorker: "Update Worker",
    viewWorker: "View Worker",
    suppliers: "Suppliers",
    newSupplier: "New Supplier",
    updateSupplier: "Update Supplier",
    viewSupplier: "View Supplier",
    retailers: "Retailers",
    newRetailer: "New Retailer",
    updateRetailer: "Update Retailer",
    viewRetailer: "View Retailer",
    drivers: "Drivers",
    newDriver: "New Driver",
    updateDriver: "Update Driver",
    viewDriver: "View Driver",
    members: "Members",
    newMember: "New Member",
    updateMember: "Update Member",
    viewMember: "View Member",

    // Product
    items: "Items",
    newItem: "New Item",
    updateItem: "Update Item",
    viewItem: "View Item",
    brands: "Brands",
    newBrand: "New Brand",
    updateBrand: "Update Brand",
    categories: "Categories",
    newCategory: "New Category",
    updateCategory: "Update Category",
    uoms: "Uoms",
    newUom: "New Uom",
    updateUom: "Update Uom",

    // Document
    salesOrders: "Sales Orders",
    newSalesOrder: "New Sales Order",
    updateSalesOrder: "Update Sales Order",
    viewSalesOrder: "View Sales Order",

    proformaSales: "Proforma Sales",
    newProformaSales: "New Proforma Sales",
    updateProformaSales: "Update Proforma Sales",
    viewProformaSales: "View Proforma Sales",

    purchaseOrders: "Purchase Orders",
    newPurchaseOrder: "New Purchase Order",
    updatePurchaseOrder: "Update Purchase Order",
    viewPurchaseOrder: "View Purchase Order",

    cashSales: "Cash Sales",
    newCashSales: "New Cash Sales",
    verifyOutCashSales: "Verify Out Cash Sales",
    viewCashSales: "View Cash Sales",

    deliveryOrders: "Delivery Orders",
    newDeliveryOrder: "New Delivery Order",
    updateDeliveryOrder: "Update Delivery Order",
    verifyOutDeliveryOrder: "Verify Out Delivery Order",
    viewDeliveryOrder: "View Delivery Order",

    deliveryTrips: "Delivery Trips",
    newDeliveryTrip: "New Delivery Trip",
    updateDeliveryTrip: "Update Delivery Trip",
    viewDeliveryTrip: "View Delivery Trip",

    pickOrders: "Pick Orders",
    newPickOrder: "New Pick Order",
    updatePickOrder: "Update Pick Order",
    viewPickOrder: "View Pick Order",

    itemReceives: "Item Receives",
    newItemReceive: "New Item Receive",
    updateItemReceive: "Update Item Receive",
    viewItemReceive: "View Item Receive",
    verifyInItemReceive: "Verify In Item Receive",

    itemTransfers: "Item Transfers",
    newItemTransfer: "New Item Transfer",
    updateItemTransfer: "Update Item Transfer",
    verifyInItemTransfer: "Verify In Item Transfer",
    verifyOutItemTransfer: "Verify Out Item Transfer",
    viewItemTransfer: "View Item Transfer",

    retailPrescriptions: "Retail Prescriptions",
    viewRetailPrescription: "View Retail Prescription",
    newRetailPrescription: "New Retail Prescription",
    updateRetailPrescription: "Update Retail Prescription",

    retailCashSales: "Retail Cash Sales",
    viewRetailCashSales: "View Retail Cash Sales",
    newRetailCashSales: "New Retail Cash Sales",
    stockRetailCashSales: "Stock Post Retail Cash Sales",

    salesDebitNotes: "Sales Debit Notes",
    newSalesDebitNote: "New Sales DN",
    updateSalesDebitNote: "Update Sales DN",
    verifyOutSalesDebitNote: "Verify Out Sales DN",
    viewSalesDebitNote: "View Sales DN",

    salesCreditNotes: "Sales Credit Notes",
    newSalesCreditNote: "New Sales CN",
    updateSalesCreditNote: "Update Sales CN",
    verifyInSalesCreditNote: "Verify In Sales CN",
    viewSalesCreditNote: "View Sales CN",

    purchaseReturns: "Purchase Returns",
    newPurchaseReturn: "New Purchase Return",
    updatePurchaseReturn: "Update Purchase Return",
    viewPurchaseReturn: "View Purchase Return",
    verifyOutPurchaseReturn: "Verify Out Purchase Return",

    replacementDelivery: "Replacement Delivery",
    newReplacementDelivery: "New Replacement Delivery",
    updateReplacementDelivery: "Update Replacement Delivery",
    viewReplacementDelivery: "View Replacement Delivery",
    verifyOutReplacementDelivery: "Verify Out Replacement Delivery",

    itemRelocates: "Item Relocates",
    newItemRelocate: "New Item Relocate",
    updateItemRelocate: "Update Item Relocate",
    viewItemRelocate: "View Item Relocate",
    itemRelocateThreshold: "Item Relocate Threshold Control",

    itemReorderThreshold: "Item Reorder Threshold Control",

    itemAdjustments: "Item Adjustments",
    newItemAdjustment: "New Item Adjustment",
    updateItemAdjustment: "Update Item Adjustment",
    viewItemAdjustment: "View Item Adjustment",
    verifyInItemAdjustment: "Verify In Item Adjustment",
    verifyOutItemAdjustment: "Verify Out Item Adjustment",

    itemTransforms: "Item Transforms",
    newItemTransform: "New Item Transform",
    viewItemTransform: "View Item Transform",

    invoices: "Invoices",
    itemRepacks: "Item Repacks",
    packingOrders: "Packing Orders",
    viewPackingOrder: "View Packing Order",

    purchaseInvoices: "Purchase Invoices",
    newPurchaseInvoice: "New Purchase Invoice",
    updatePurchaseInvoice: "Update Purchase Invoice",
    viewPurchaseInvoice: "View Purchase Invoice",

    itemIssues: "Item Issues",
    newItemIssue: "New Item Issue",
    updateItemIssue: "Update Item Issue",
    viewItemIssue: "View Item Issue",
    verifyOutItemIssue: "Verify Out Item Issue",

    stockTakes: "Stock Takes",
    newStockTake: "New Stock Take",
    updateStockTake: "Update Stock Take",
    viewStockTake: "View Stock Take",

    transferReturns: "Transfer Returns",
    newTransferReturn: "New Transfer Return",
    updateTransferReturn: "Update Transfer Return",
    viewTransferReturn: "View Transfer Return",
    verifyInTransferReturn: "Verify In Transfer Return",
    verifyOutTransferReturn: "Verify Out Transfer Return",

    transferRequisitions: "Transfer Requisitions",
    newTransferRequisition: "New Transfer Requisition",
    updateTransferRequisition: "Update Transfer Requisition",
    viewTransferRequisition: "View Transfer Requisition",

    salesInvoices: "Sales Invoices",
    newSalesInvoice: "New Sales Invoice",
    updateSalesInvoice: "Update Sales Invoice",
    viewSalesInvoice: "View Sales Invoice",

    // Logistic
    transporters: "Transporters",
    newTransporter: "New Transporter",
    updateTransporter: "Update Transporter",

    // Repository
    containers: "Containers",
    newContainer: "New Container",
    updateContainer: "Update Container",

    packages: "Packages",
    newPackage: "New Package",
    updatePackage: "Update Package",
    viewPackage: "View Package",
    packPackage: "Pack Package",

    // Group
    administratorGroups: "Administrator Groups",
    newAdministratorGroup: "New Administrator Group",
    updateAdministratorGroup: "Update Administrator Group",
    customerGroups: "Customer Groups",
    newCustomerGroup: "New Customer Group",
    updateCustomerGroup: "Update Customer Group",
    supplierGroups: "Supplier Groups",
    newSupplierGroup: "New Supplier Group",
    updateSupplierGroup: "Update Supplier Group",

    // Setting
    locations: "Locations",
    newLocation: "New Location",
    updateLocation: "Update Location",
    regions: "Regions",
    updateRegion: "Update Region",
    customFields: "Custom Fields",
    newCustomFields: "New Custom Field",
    updateCustomField: "Update Custom Field",
    injectionProps: "Injection Props",
    newInjectionProp: "New Injection Prop",
    injectionFields: "Injection Fields",
    newInjectionField: "New Injection Field",
    business: "Businesses",
    newBusiness: "New Business",
    updateBusiness: "Update Business",
    viewBusiness: "View Business",
    account: "Account",
    roles: "Roles",
    newRole: "New Role",
    updateRole: "Update Role",
    rates: "Shipping Rates",
    newRate: "New Shipping Rate",
    updateRate: "Update Shipping Rate",
    viewRate: "View Shipping Rate",
    rules: "Shipping Rules",
    newRule: "New Shipping Rule",
    updateRule: "Update Shipping Rule",
    viewRule: "View Shipping Rule",
    taxRates: "Tax Rates",
    newTaxRate: "New Tax Rate",
    updateTaxRate: "Update Tax Rate",
    audits: "Audit Trails",
    newAudit: "New Audit Trail",
    viewAudit: "View Audit Trail",
    tags: "Audit Trail Tags",

    // Wallet
    wallets: "Wallets",
    newWallet: "New Wallet",
    updateWallet: "Update Wallet",
    viewWallet: "View Wallet",

    // Request - wallet
    walletRequests: "Wallet Requests",
    newWalletRequest: "New Wallet Request",
    updateWalletRequest: "Update Wallet Request",
    viewWalletRequest: "View Wallet Request",

    // Transaction - wallet
    walletTransaction: "Wallet Transaction",
    newWalletTransaction: "New Wallet Transaction",
    updateWalletTransaction: "Update Wallet Transaction",
    viewWalletTransaction: "View Wallet Transaction",

    // User API Keys
    userApiKey: "User API Key",
    newUserApiKey: "New User API Key",
    updateUserApiKey: "Update User API Key",
    viewUserApiKey: "View User API Key",

    // Report
    deliveryReports: "Delivery Reports",
    itemReceiveReports: "Item Receive Reports",
    itemTransferReports: "Item Transfer Reports",
    retailCashSalesReports: "Retail Cash Sales Reports",
    retailPrescriptionReports: "Retail Prescription Reports",
    salesReports: "Sales Reports",
    productReports: "Product Reports",
    stockValueReports: "Stock Value Reports",

    // Examine Inventory
    viewInventory: "Examine Inventory",

    // Scheduler
    tasks: "Tasks",
    newTask: "New Task",
    updateTask: "Update Task",
    logs: "Logs",
    viewLog: "View Log",
    requests: "Requests",
    newRequest: "New Request",
    updateRequest: "Update Request",
    viewRequest: "View Request",
    console: "Console",
    // newLog: "New Log",
    // updateLog: "Update Log",


}

export function useSystemHead(_routeType = '') {

    const [routeType, setRouteType] = useState(_routeType)

    const getHtmlHead = ({ title }) => {
        return (
            <Helmet>
                <title>{capitalizeString({ val: routeType })} : {title}</title>
            </Helmet>
        )
    }

    return { getHtmlHead }
}